module.exports = __webpack_public_path__ + "static/media/diet.4df72d08.svg";